import { NotificationSettingTypeFormModel } from './NotificationSettingTypeForm';
import { NotificationSettingFormModel } from './NotificationSettingForm';
import { NotificationType, NotificationCodeType } from './Constants';
var NotificationSettingMethodFormModel = /** @class */ (function () {
    function NotificationSettingMethodFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.requestBudget, requestBudget = _b === void 0 ? new NotificationSettingTypeFormModel() : _b, _c = _a.requestCreative, requestCreative = _c === void 0 ? new NotificationSettingTypeFormModel() : _c, _d = _a.google_creative, google_creative = _d === void 0 ? new NotificationSettingTypeFormModel() : _d, _e = _a.system, system = _e === void 0 ? new NotificationSettingFormModel() : _e;
        this.requestBudget = requestBudget;
        this.requestCreative = requestCreative;
        this.googleCreative = google_creative;
        this.system = system;
    }
    NotificationSettingMethodFormModel.prototype.createNotificationSetting = function (data) {
        if (data.notificationType.includes(NotificationCodeType.google))
            this.googleCreative.createNotificationSetting(data);
        else if (data.notificationType.includes(NotificationCodeType.creative))
            this.requestCreative.createNotificationSetting(data);
        else if (data.notificationType.includes(NotificationCodeType.budget))
            this.requestBudget.createNotificationSetting(data);
        else if (data.notificationType.includes(NotificationType.system))
            this.system = new NotificationSettingFormModel({
                id: data.id,
                accountId: data.accountId,
                isNotify: data.isNotify,
                frequency: data.frequency,
            });
    };
    Object.defineProperty(NotificationSettingMethodFormModel.prototype, "isCreativeEmpty", {
        get: function () {
            return (this.requestCreative.audit.isNotify === false &&
                this.requestCreative.reject.isNotify === false &&
                this.googleCreative.audit.isNotify === false &&
                this.googleCreative.reject.isNotify === false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationSettingMethodFormModel.prototype, "isRequestEmpty", {
        get: function () {
            return (this.requestBudget.audit.isNotify === false &&
                this.requestBudget.reject.isNotify === false);
        },
        enumerable: false,
        configurable: true
    });
    NotificationSettingMethodFormModel.prototype.setAllRequestIsNotify = function (val) {
        this.requestBudget.audit.isNotify = val;
        this.requestBudget.reject.isNotify = val;
    };
    NotificationSettingMethodFormModel.prototype.setAllCreativeIsNotify = function (val) {
        this.requestCreative.audit.isNotify = val;
        this.requestCreative.reject.isNotify = val;
        this.googleCreative.audit.isNotify = val;
        this.googleCreative.reject.isNotify = val;
    };
    NotificationSettingMethodFormModel.prototype.passToCorrespondingCodeType = function (items, method, accountId) {
        this.requestBudget.passToCorrespondingStatusType(items, method, 'request_budget_', accountId);
        this.requestCreative.passToCorrespondingStatusType(items, method, 'request_creative_', accountId);
        this.googleCreative.passToCorrespondingStatusType(items, method, 'request_creative_google_', accountId);
        this.system.addChangedNotification(items, method, 'system', '', accountId);
    };
    return NotificationSettingMethodFormModel;
}());
export { NotificationSettingMethodFormModel };
